// extracted by mini-css-extract-plugin
export default {"KeyGiverDropsStatsInfo":"KeyGiverDropsStatsInfo_KeyGiverDropsStatsInfo__ckeOT"};